import React from 'react';

type Props = {
  title: string;
  children: React.ReactNode;
  className?: string;
};

export default ({ title, children, className }: Props) => {
  return (
    <div className={`flex flex-col gap-2 flex-1 ${className || ''}`}>
      <h3 className="font-bold text-[10px] leading-none text-gray-400 m-0" style={{ letterSpacing: '1.5%' }}>
        {title}
      </h3>
      <div className="flex flex-wrap gap-2 max-w-[485px]">
        {children}
      </div>
    </div>
  );
};